import Phaser from 'phaser';
import { setUiScale } from './scale';

/**
 * Viewport / High-DPI handling, shared by main.ts and BootScene.
 *
 * The Phaser canvas backing store is sized at (CSS size × DPR) and displayed at
 * CSS size, so rendering is crisp on High-DPI / scaled displays. Scene layout
 * is authored in logical pixels (see scale.ts) and multiplied by the same DPR.
 */

/** Live device-pixel ratio, floored at 1 and capped at 2 for fill-rate. */
export function currentDpr(): number {
  const raw = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
  return Math.min(Math.max(raw || 1, 1), 2);
}

/**
 * Resize the canvas backing store to match the window at the current DPR and
 * update the shared UI scale. Returns the DPR that was applied.
 */
export function fitCanvas(game: Phaser.Game): number {
  const dpr = currentDpr();
  const cssW = window.innerWidth;
  const cssH = window.innerHeight;

  game.scale.resize(cssW * dpr, cssH * dpr);

  const canvas = game.canvas;
  if (canvas) {
    canvas.style.width = `${cssW}px`;
    canvas.style.height = `${cssH}px`;
  }

  setUiScale(dpr);
  return dpr;
}
